import React, { useState } from 'react';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';
import { HighlightedText } from './HighlightedText';
import './TestimonyAccordion.css';

export default function TestimonyAccordion({ items }) {
  const [openIndices, setOpenIndices] = useState(
    () => new Set(items.map((_, index) => index)),
  );

  const toggle = (index) => {
    setOpenIndices((prev) => {
      const next = new Set(prev);
      if (next.has(index)) {
        next.delete(index);
      } else {
        next.add(index);
      }
      return next;
    });
  };

  return (
    <div className="divide-y divide-warm-200 border border-warm-200 rounded-xl overflow-hidden bg-white">
      {items.map((item, index) => {
        const open = openIndices.has(index);
        const panelId = `testimony-panel-${item.id}`;
        const headerId = `testimony-header-${item.id}`;

        return (
          <div key={item.id}>
            <button
              type="button"
              id={headerId}
              aria-expanded={open}
              aria-controls={panelId}
              className="w-full flex justify-between items-start gap-4 px-6 md:px-8 py-4 text-left cursor-pointer hover:bg-warm-50 transition-colors"
              onClick={() => toggle(index)}
            >
              <div>
                <p className="text-xs font-medium uppercase tracking-wide text-construx-red mb-1">
                  {String(item.id).padStart(2, '0')} — {item.topic}
                </p>
                <p className="text-base md:text-lg font-semibold text-warm-900">{item.question}</p>
              </div>
              <span className="shrink-0 mt-1 text-warm-600" aria-hidden="true">
                {open ? <FaChevronUp /> : <FaChevronDown />}
              </span>
            </button>
            <div
              id={panelId}
              role="region"
              aria-labelledby={headerId}
              className={`transition-[max-height] ease-in-out duration-300 overflow-hidden ${
                open ? 'max-h-[4000px]' : 'max-h-0'
              }`}
            >
              <div
                className={`transition-opacity duration-300 px-6 md:px-8 pb-5 text-warm-700 space-y-3 ${
                  open ? 'opacity-100' : 'opacity-0'
                }`}
              >
                {item.answer.map((paragraph, i) => (
                  <p key={i}>
                    <HighlightedText text={paragraph} highlights={item.highlights} />
                  </p>
                ))}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
